/* eslint-disable import/prefer-default-export */
import { styled, Link } from "@mui/material";

export const LearnButton = styled(Link)(({ theme }) => ({
    width: "300px",
    height: "70px",
    padding: "14px 28px",
    borderRadius: "4px",
    textDecoration: "none",
    fontSize: "20px",
    color: "#fff",
    background:
        theme.palette.mode === "dark"
            ? "linear-gradient(to right, #22edfb 50%, #042c54 50%)"
            : "linear-gradient(to right, #f0d43a 50%, #d6bd33 50%)",
    backgroundSize: "200% 100%",
    backgroundPosition: "right bottom",
    transition: "background-position 0.5s ease, color 0.2s ease",
    textAlign: "center",
    display: "flex", // Flexbox для центрирования
    justifyContent: "center", // Центрирование по горизонтали
    alignItems: "center",
    "&:hover": {
        backgroundPosition: "left bottom",
        color: "#000",
    },

    [theme.breakpoints.down("sm")]: {
        width: "100%",
    },
}));
